import React from "react"
import classes from "./knowledgeReport.module.css"
import { MyProfileWithPath } from "./MyProfileWithPath"
import { ScoreCards } from "./scoreCards"
import DashboardLayout from "../../../DashboardLayout/DashboardLayout"


export const KnowledgeReport = () => {

    return (
        <>
            <DashboardLayout>
                <div>
                    <MyProfileWithPath />

                    <div className={classes.PageBody}>
                        <div className={classes.content}>
                            <ScoreCards />
                        </div>
                    </div>
                </div>

            </DashboardLayout>

        </>
    )


}